import Button from '../Button/Button';
import type { ErrorMessageProps } from './ErrorMessage.types';

export default function ErrorMessage(props: ErrorMessageProps) {
  const {
    className = '',
    contentClassName = '',
    actionIcon,
    title,
    description,
    buttonLabel,
    buttonClassName = '',
    onButtonClick = () => null,
  } = props;

  return (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`}>
      <div className={`flex flex-col items-center gap-2 ${contentClassName}`}>
        <h3 className="text-center font-unibet font-medium text-[24px] leading-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
          {title}
        </h3>
        <span className="text-center whitespace-pre-line font-robotoRegular font-normal text-[12px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
          {description}
        </span>
      </div>

      {!!buttonLabel && (
        <Button className={buttonClassName} onClick={onButtonClick}>
          <span className="flex items-center justify-center gap-2 text-center whitespace-normal wrap-break-word">
            {actionIcon}
            <span className="min-w-0 wrap-break-word">{buttonLabel}</span>
          </span>
        </Button>
      )}
    </div>
  );
}
